import CollectionsSalesAnalytics from '@assets/icons/collections-sales-analytics.svg'
import { Icon } from './Icon'

export const CollectionsSalesAnalyticsIcon = Icon(CollectionsSalesAnalytics)
